// extracted by mini-css-extract-plugin
export default {"character":"CharacterDetail_character__PExL2","category":"CharacterDetail_category__vuLil"};